import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-location-bpams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-location-bpams.component.scss?ngResource";
import { ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { AppControllerService } from "../../../../app-controller.service";
import { MapService } from "../../../../map/shared/map.service";
import { RequestStatusService } from "../../../../shared/services/request-status/request-status.service";
import { FormArray, FormControl, FormGroup } from "@angular/forms";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
import { ApiProxyConstants } from "../../../../shared/constants/api-constants/api-proxy.constants";
import { AppConfig } from "../../../../app.config";
import { AppRoutingConstants } from "../../../../app-routing.constants";
import { UrlConstants } from "../../../../shared/constants/url.constants";
import { WktConverterUtils } from "../../../../shared/utils/wkt-converter-utils";
import * as JsonUtils from "@arcgis/core/geometry/support/jsonUtils";
import { ViewApplicationLocationBpamsConstants } from "./view-application-location-bpams.constants";
import { PropertyBuildingHeadingEnumHeadingLookup } from "./property-building-heading.model";
import { BehaviorSubject } from "rxjs";
import { ViewApplicationBaseComponent } from "../../../shared/view-application-base/view-application-base.component";
import { ApplicationViewService } from "../../../shared/application-view.service";
import { RouterParamsService } from "../../../../shared/services/route-params.service";
import { AutoUnsubPortal } from "../../../../shared/decorators/autounsub-portal.decorator";
let ViewApplicationLocationBpamsComponent = class ViewApplicationLocationBpamsComponent extends ViewApplicationBaseComponent {
    applicationViewService;
    aflaModuleStrategyService;
    selectedApplicationService;
    appController;
    mapService;
    requestStatusService;
    changeDetectorRefs;
    routerParamsService;
    active;
    propertiesForm;
    erfNoControl = ViewApplicationLocationBpamsConstants.ERF_NO_CONTROL;
    subdivisionControl = ViewApplicationLocationBpamsConstants.SUBDIVISION_CONTROL;
    allotmentControl = ViewApplicationLocationBpamsConstants.ALLOTMENT_CONTROL;
    farmNoControl = ViewApplicationLocationBpamsConstants.FARM_NO_CONTROL;
    sgCodeControl = ViewApplicationLocationBpamsConstants.SG_CODE_CONTROL;
    addressControl = ViewApplicationLocationBpamsConstants.ADDRESS_CONTROL;
    erfSizeControl = ViewApplicationLocationBpamsConstants.ERF_SIZE_CONTROL;
    titleDeedControl = ViewApplicationLocationBpamsConstants.TITLE_DEED_CONTROL;
    zoneControl = ViewApplicationLocationBpamsConstants.ZONE_CONTROL;
    ownerControl = ViewApplicationLocationBpamsConstants.OWNER_CONTROL;
    propertiesControl = ViewApplicationLocationBpamsConstants.PROPERTIES_CONTROL;
    erfNoTextPlaceHolder = ViewApplicationLocationBpamsConstants.ERF_NO_TEXT_PLACEHOLDER;
    subdivisionTextPlaceHolder = ViewApplicationLocationBpamsConstants.SUBDIVISION_TEXT_PLACEHOLDER;
    allotmentTextPlaceHolder = ViewApplicationLocationBpamsConstants.ALLOTMENT_TEXT_PLACEHOLDER;
    farmNoTextPlaceHolder = ViewApplicationLocationBpamsConstants.FARM_NO_TEXT_PLACEHOLDER;
    sgCodeTextPlaceHolder = ViewApplicationLocationBpamsConstants.SG_CODE_TEXT_PLACEHOLDER;
    addressTextPlaceHolder = ViewApplicationLocationBpamsConstants.ADDRESS_TEXT_PLACEHOLDER;
    erfSizeTextPlaceHolder = ViewApplicationLocationBpamsConstants.ERF_SIZE_TEXT_PLACEHOLDER;
    titleDeedTextPlaceHolder = ViewApplicationLocationBpamsConstants.TITLE_DEED_TEXT_PLACEHOLDER;
    zoneLabel = ViewApplicationLocationBpamsConstants.ZONE_LABEL;
    addZoneLabel = ViewApplicationLocationBpamsConstants.ADD_ZONE_LABEL;
    removePropertyLabel = ViewApplicationLocationBpamsConstants.REMOVE_PROPERTY_LABEL;
    ownerLabel = ViewApplicationLocationBpamsConstants.OWNER_LABEL;
    ownerDisableFilterBy = true;
    ownerDisableAdd = true;
    ownerDisableEditing = true;
    ownerDisableDelete = true;
    ownerShowGroupsDropdown = true;
    ownerGroups = [];
    ownerListLabel = "Owner";
    fullApplicationCheckRequired = false;
    showOnlyPropertyAndZoningLayers = true;
    propertyDescriptionTextPlaceHolder = ViewApplicationLocationBpamsConstants.PROPERTY_DESCRIPTION_LABEL;
    propertyDescriptionControl = ViewApplicationLocationBpamsConstants.PROPERTY_DESCRIPTION_CONTROL;
    titleDeedRestrictionsTextPlaceHolder = ViewApplicationLocationBpamsConstants.TITLE_DEED_RESTRICTION_LABEL;
    titleDeedRestrictionsControl = ViewApplicationLocationBpamsConstants.TITLE_DEED_RESTRICTION_CONTROL;
    externalWallsTextPlaceHolder = ViewApplicationLocationBpamsConstants.EXTERNAL_WALLS_LABEL;
    internalWallsTextPlaceHolder = ViewApplicationLocationBpamsConstants.INTERNAL_WALLS_LABEL;
    roofingTextPlaceHolder = ViewApplicationLocationBpamsConstants.ROOFING_LABEL;
    numberOfHousesUnitsTextPlaceHolder = ViewApplicationLocationBpamsConstants.NUMBER_OF_HOUSES_UNITS_LABEL;
    externalWallsControl = ViewApplicationLocationBpamsConstants.EXTERNAL_WALLS_CONTROL;
    internalWallsControl = ViewApplicationLocationBpamsConstants.INTERNAL_WALLS_CONTROL;
    roofingControl = ViewApplicationLocationBpamsConstants.ROOFING_CONTROL;
    numberOfHousesUnitsControl = ViewApplicationLocationBpamsConstants.NUMBER_OF_HOUSES_UNITS_CONTROL;
    buildingDetailsLabel = ViewApplicationLocationBpamsConstants.BUILDING_DETAILS_LABEL;
    mainBuildingLabel = ViewApplicationLocationBpamsConstants.MAIN_BUILDING_LABEL;
    outBuildingLabel = ViewApplicationLocationBpamsConstants.OUT_BUILDING_LABEL;
    totalLabel = ViewApplicationLocationBpamsConstants.TOTAL_LABEL;
    buildingTotalLabel = ViewApplicationLocationBpamsConstants.BUILDING_TOTAL_LABEL;
    stoepLabel = ViewApplicationLocationBpamsConstants.STOEP_LABEL;
    miscellaneousLabel = ViewApplicationLocationBpamsConstants.MISCELLANEOUS_LABEL;
    totalExistingPlaceHolder = ViewApplicationLocationBpamsConstants.TOTAL_EXISTING_LABEL;
    totalAddedTextPlaceHolder = ViewApplicationLocationBpamsConstants.TOTAL_ADDED_LABEL;
    totalFloorAreaTextPlaceHolder = ViewApplicationLocationBpamsConstants.TOTAL_FLOOR_AREA_LABEL;
    totalExistingControl = ViewApplicationLocationBpamsConstants.TOTAL_EXISTING_CONTROL;
    totalAddedControl = ViewApplicationLocationBpamsConstants.TOTAL_ADDED_CONTROL;
    totalFloorAreaControl = ViewApplicationLocationBpamsConstants.TOTAL_FLOOR_AREA_CONTROL;
    // patio
    coveredExistingTextPlaceHolder = ViewApplicationLocationBpamsConstants.COVERED_EXISTING_LABEL;
    coveredAddedTextPlaceHolder = ViewApplicationLocationBpamsConstants.COVERED_ADDED_LABEL;
    openExistingTextPlaceHolder = ViewApplicationLocationBpamsConstants.OPEN_EXISTING_LABEL;
    openAddedTextPlaceHolder = ViewApplicationLocationBpamsConstants.OPEN_ADDED_LABEL;
    totalExistingPatioTextPlaceHolder = ViewApplicationLocationBpamsConstants.TOTAL_EXISTING_PATIO_LABEL;
    totalAddedPatioTextPlaceHolder = ViewApplicationLocationBpamsConstants.TOTAL_ADDED_PATIO_LABEL;
    coveredExistingControl = ViewApplicationLocationBpamsConstants.COVERED_EXISTING_CONTROL;
    coveredAddedControl = ViewApplicationLocationBpamsConstants.COVERED_ADDED_CONTROL;
    openExistingControl = ViewApplicationLocationBpamsConstants.OPEN_EXISTING_CONTROL;
    openAddedControl = ViewApplicationLocationBpamsConstants.OPEN_ADDED_CONTROL;
    totalExistingPatioControl = ViewApplicationLocationBpamsConstants.TOTAL_EXISTING_PATIO_CONTROL;
    totalAddedPatioControl = ViewApplicationLocationBpamsConstants.TOTAL_ADDED_PATIO_CONTROL;
    // misc
    poolTextPlaceHolder = ViewApplicationLocationBpamsConstants.POOL_LABEL;
    boundaryWallHeightTextPlaceHolder = ViewApplicationLocationBpamsConstants.BOUNDARY_WALL_HEIGHT_LABEL;
    boundaryWallRunningTextPlaceHolder = ViewApplicationLocationBpamsConstants.BOUNDARY_WALL_RUNNING_LABEL;
    coverageTextPlaceHolder = ViewApplicationLocationBpamsConstants.COVERAGE_LABEL;
    bulkCalculationTextPlaceHolder = ViewApplicationLocationBpamsConstants.BULK_CALCULATION_LABEL;
    calculationsLabel = ViewApplicationLocationBpamsConstants.CALCULATIONS_LABEL;
    poolControl = ViewApplicationLocationBpamsConstants.POOL_CONTROL;
    boundaryWallHeightControl = ViewApplicationLocationBpamsConstants.BOUNDARY_WALL_HEIGHT_CONTROL;
    boundaryWallRunningControl = ViewApplicationLocationBpamsConstants.BOUNDARY_WALL_RUNNING_CONTROL;
    coverageControl = ViewApplicationLocationBpamsConstants.COVERAGE_CONTROL;
    bulkCalculationControl = ViewApplicationLocationBpamsConstants.BULK_CALCULATION_CONTROL;
    propertyApplicationDetailsLabel = ViewApplicationLocationBpamsConstants.PROPERTY_APPLICATION_DETAILS_LABEL;
    removeDialogTitle = ViewApplicationLocationBpamsConstants.REMOVE_DIALOG_TEXT;
    selectPromptMessage = "Delete-test";
    zones = [];
    mainTableMapper;
    outTableMapper;
    mapComponent;
    isMapLoaded = false;
    application;
    applicationLoaded = false;
    getTrueCentroidSubscription;
    getLookupsObservableSubscription;
    selectedApplicationSubscription;
    constructor(applicationViewService, aflaModuleStrategyService, selectedApplicationService, appController, mapService, requestStatusService, changeDetectorRefs, routerParamsService) {
        super(applicationViewService, aflaModuleStrategyService, selectedApplicationService, routerParamsService);
        this.applicationViewService = applicationViewService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.appController = appController;
        this.mapService = mapService;
        this.requestStatusService = requestStatusService;
        this.changeDetectorRefs = changeDetectorRefs;
        this.routerParamsService = routerParamsService;
        this.initForm();
        this.initializeColumnToObjectMapping();
        this.listenForSelectedApplication();
        this.getMetadata();
    }
    ngOnInit() {
        this.getZoningLookups();
        this.listenForRouteParamChange();
    }
    ngAfterViewInit() {
        this.mapService.actionPropertyEnabled = false;
    }
    ngOnDestroy() {
        this.mapService.actionPropertyEnabled = false;
        this.mapService.destroyMap();
    }
    mapLoaded() {
        this.isMapLoaded = true;
        this.syncMapGeometries();
    }
    loadMetadata(stepMeta) {
        this.ownerGroups = stepMeta.ownerGroup;
        this.ownerGroups[0].requiredFields = stepMeta.requiredFields;
    }
    getProperties() {
        if (this.propertiesForm) {
            return this.propertiesForm.get(this.propertiesControl);
        }
    }
    getZones(propertyIndex) {
        return this.getProperties().controls[propertyIndex].get(this.zoneControl);
    }
    mainArrayReturned(array, index) {
        this.getProperties().controls[index].get("mainTableSelection").setValue(array);
    }
    outArrayReturned(array, index) {
        this.getProperties().controls[index].get("outTableSelection").setValue(array);
    }
    // TODO Disable styles on template
    disablePropertyControls(propertyIndex) {
        const propertyControl = this.getProperties().controls[propertyIndex];
        propertyControl.get(this.erfNoControl).disable();
        propertyControl.get(this.subdivisionControl).disable();
        propertyControl.get(this.allotmentControl).disable();
        propertyControl.get(this.sgCodeControl).disable();
        propertyControl.get(this.addressControl).disable();
        // propertyControl.get(this.buildingUseControl).disable();
        propertyControl.get(this.erfNoControl).disable();
        // propertyControl.get(this.buildingFloorAreaControl).disable();
        propertyControl.get(this.titleDeedControl).disable();
    }
    setZonesControls(newPropertyFormGroup, property) {
        const zonesControl = newPropertyFormGroup.get(this.zoneControl);
        if (property.zonings && property.zonings.length > 0) {
            property.zonings.forEach(zone => {
                let foundZone = false;
                this.zones.forEach(zoneOption => {
                    if (zoneOption.value === zone.zoning) {
                        foundZone = true;
                        const zoneGroup = new FormGroup({
                            id: new FormControl(zone.id),
                            applicationId: new FormControl(zone.applicationId),
                            applicationPropertyId: new FormControl(zone.applicationPropertyId),
                            zones: new FormControl({ value: zoneOption, disabled: true }),
                            deleted: new FormControl(zone.deleted)
                        });
                        zonesControl.push(zoneGroup);
                        zonesControl.disable();
                    }
                });
            });
        }
        else {
            const zoneGroup = new FormGroup({
                id: new FormControl(null),
                applicationId: new FormControl(null),
                applicationPropertyId: new FormControl(null),
                zones: new FormControl({ value: null, disabled: true }),
                deleted: new FormControl(null)
            });
            zonesControl.push(zoneGroup);
            zonesControl.disable();
        }
    }
    setTrueCentroid(geometryArc, newPropertyFormGroup, propertyControl, property) {
        const proxyUrl = ApiProxyConstants.URL;
        const gpToolUrl = AppConfig.settings.arcGIS.servicesURL + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
        const url = `${proxyUrl}?${gpToolUrl}`;
        const formData = new FormData();
        formData.append("f", "json");
        formData.append("geometryJSON", JSON.stringify(geometryArc));
        this.getTrueCentroidSubscription = this.applicationViewService.getTrueCentroid(url, formData).subscribe({
            next: (response) => {
                newPropertyFormGroup.get("centroid").setValue(response.results[0].value);
                propertyControl.push(newPropertyFormGroup);
                this.active = propertyControl.length - 1;
                this.setZonesControls(newPropertyFormGroup, property);
                this.disablePropertyControls(propertyControl.length - 1);
                this.syncMapGeometries();
                this.changeDetectorRefs.detectChanges();
            }, error: (error) => {
                this.appController.handleServerErrorMessage(ViewApplicationLocationBpamsConstants.TRUE_CENTROID, error, CRUDOperation.Get);
            }
        });
    }
    syncMainBuildings(PropertyFormGroup) {
        const items = PropertyFormGroup.get("mainTableDataSource").value.getValue();
        const formItems = PropertyFormGroup.get("mainBuildings");
        formItems.clear();
        items.forEach(item => {
            const newItem = new FormGroup({
                floor: new FormControl(item.floor),
                existingSize: new FormControl(item.existingSize),
                addedSize: new FormControl(item.addedSize),
                buildingNameNumber: new FormControl(item.buildingNameNumber)
            });
            formItems.push(newItem);
        });
    }
    syncOutBuildings(PropertyFormGroup) {
        const items = PropertyFormGroup.get("outTableDataSource").value.getValue();
        const formItems = PropertyFormGroup.get("outBuildings");
        formItems.clear();
        items.forEach(item => {
            const newItem = new FormGroup({
                floor: new FormControl(item.floor),
                existingSize: new FormControl(item.existingSize),
                addedSize: new FormControl(item.addedSize),
                buildingNameNumber: new FormControl(item.buildingNameNumber)
            });
            formItems.push(newItem);
        });
    }
    handleRouteChange() {
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get("propertiesForm");
        this.propertiesForm = form;
    }
    initializeColumnToObjectMapping() {
        this.mainTableMapper = PropertyBuildingHeadingEnumHeadingLookup;
        this.outTableMapper = PropertyBuildingHeadingEnumHeadingLookup;
    }
    getZoningLookups() {
        const params = {
            $filter: `moduleId eq ${this.appController.selectedModuleID} and name eq 'Zoning'`,
        };
        this.getLookupsObservableSubscription = this.applicationViewService.getLookupsObservable(params).subscribe({
            next: (response) => {
                if (response && response.value && response.value.length > 0) {
                    const zoningLookups = response.value;
                    this.onGetZoningLookupsCompleted(zoningLookups);
                }
            }, error: (error) => {
                this.appController.handleServerErrorMessage(ViewApplicationLocationBpamsConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetZoningLookupsCompleted(zoningLookups) {
        zoningLookups.forEach(zoneObject => {
            this.zones.push(JSON.parse(zoneObject.content));
        });
        this.getMetadata();
    }
    syncMapGeometries() {
        const geometries = [];
        this.getProperties().controls.forEach(item => {
            const geom = item.get("geometry").value;
            if (geom !== null) {
                geometries.push(geom);
            }
        });
        if (geometries.length > 0) {
            this.mapComponent.addGeometriesOnMap(geometries, ViewApplicationLocationBpamsConstants.LAYER_REF, true);
        }
        this.changeDetectorRefs.detectChanges();
    }
    listenForSelectedApplication() {
        this.selectedApplicationSubscription = this.selectedApplicationService.$selectedApplication.subscribe({
            next: (application) => {
                if (application && application.id >= 0 && !this.applicationLoaded) {
                    this.application = application;
                    this.setApplicationData();
                    this.applicationLoaded = true;
                }
            }
        });
    }
    setApplicationData() {
        if (this.application && this.application.properties && this.application.properties.length > 0) {
            if (!this.getProperties()) {
                return;
            }
            else {
                this.getProperties().clear();
                const propertyControl = this.getProperties();
                let index = 0;
                this.application.properties.sort((a, b) => (b?.id - a?.id))?.forEach((property) => {
                    // create form groups for each property
                    const geometryArc = WktConverterUtils.ConvertWktToArcGisJson(property.shape, 102100);
                    const geom = JsonUtils.fromJSON(geometryArc);
                    const newPropertyFormGroup = this.createFormGroup(property, geom);
                    this.propertiesForm.markAllAsTouched();
                    this.setTrueCentroid(geometryArc, newPropertyFormGroup, propertyControl, property);
                    index++;
                });
            }
        }
    }
    createFormGroup(property, geom) {
        const _form = new FormGroup({
            property: new FormControl(property),
            erfNo: new FormControl({ value: property.erfNumber, disabled: true }),
            allotment: new FormControl({ value: property.allotment, disabled: true }),
            farmNo: new FormControl({ value: property.farmNumber, disabled: true }),
            sgCode: new FormControl({ value: property.sgCode, disabled: true }),
            address: new FormControl({ value: property.address, disabled: true }),
            erfSize: new FormControl({ value: property.erfSize, disabled: true }),
            titleDeed: new FormControl({ value: property.titleDeed, disabled: true }),
            subdivision: new FormControl({ value: property.subdivision, disabled: true }),
            propertyDescription: new FormControl({ value: property.applicationDescription, disabled: true }),
            applicationRestrictions: new FormControl({ value: property.applicationRestrictions, disabled: true }),
            externalWalls: new FormControl({ value: property.externalWalls, disabled: true }),
            internalWalls: new FormControl({ value: property.internalWalls, disabled: true }),
            roofing: new FormControl({ value: property.roofing, disabled: true }),
            numberOfHouses: new FormControl({ value: property.numberOfHouses, disabled: true }),
            patioCoveredExisting: new FormControl({ value: property.patioCoveredExisting, disabled: true }),
            patioCoveredAdded: new FormControl({ value: property.patioCoveredAdded, disabled: true }),
            patioOpenExisting: new FormControl({ value: property.patioOpenExisting, disabled: true }),
            patioOpenAdded: new FormControl({ value: property.patioOpenAdded, disabled: true }),
            totalExistingPatio: new FormControl({ value: null, disabled: true }),
            totalAddedPatio: new FormControl({ value: null, disabled: true }),
            pool: new FormControl({ value: property.pool, disabled: true }),
            boundaryWallHeight: new FormControl({ value: property.boundaryWallHeight, disabled: true }),
            boundaryWallRunning: new FormControl({ value: property.boundaryWallRunning, disabled: true }),
            coverage: new FormControl({ value: property.coverage, disabled: true }),
            bulkCalculation: new FormControl({ value: property.bulkCalculation, disabled: true }),
            geometry: new FormControl(geom),
            centroid: new FormControl(null),
            zones: new FormArray([]),
            buildings: new FormArray([]),
            owners: new FormControl(property.owners),
            mainBuildings: new FormArray([]),
            outBuildings: new FormArray([]),
            mainTableDataSource: new FormControl(new BehaviorSubject([])),
            mainTableSelection: new FormControl([]),
            outTableDataSource: new FormControl(new BehaviorSubject([])),
            outTableSelection: new FormControl([]),
            totalExisting: new FormControl({ value: 0, disabled: true }),
            totalAdded: new FormControl({ value: 0, disabled: true }),
            totalFloorArea: new FormControl({ value: 0, disabled: true }),
        });
        const mainTableDataSource = _form.get("mainTableDataSource").value;
        const outTableDataSource = _form.get("outTableDataSource").value;
        const mainItems = [];
        const outItems = [];
        property.buildings.forEach(building => {
            if (building.type === "Main Building") {
                mainItems.push(building);
            }
            else {
                outItems.push(building);
            }
        });
        mainTableDataSource.next(mainItems);
        outTableDataSource.next(outItems);
        this.syncMainBuildings(_form);
        this.syncOutBuildings(_form);
        this.calculateTotals(_form);
        return _form;
    }
    calculateTotals(PropertyFormGroup) {
        PropertyFormGroup.get("coverage").setValue(0);
        PropertyFormGroup.get("bulkCalculation").setValue(0);
        let totalExistingPatioCalculated = 0.00;
        let totalAddedPatioCalculated = 0.00;
        let totalExistingCalculated = 0.00;
        let totalAddedCalculated = 0.00;
        let totalFloorCalculated = 0.00;
        let totalGroundFloorCalculated = 0.00;
        try {
            if (PropertyFormGroup.get("patioCoveredExisting").value !== null && PropertyFormGroup.get("patioCoveredAdded").value !== null && PropertyFormGroup.get("patioOpenExisting").value !== null && PropertyFormGroup.get("patioOpenAdded").value !== null) {
                const patioCoverageExisting = PropertyFormGroup.get("patioCoveredExisting").value;
                const patioCoverageAdded = PropertyFormGroup.get("patioCoveredAdded").value;
                const patioOpenExisting = PropertyFormGroup.get("patioOpenExisting").value;
                const patioOpenAdded = PropertyFormGroup.get("patioOpenAdded").value;
                totalExistingPatioCalculated += patioCoverageExisting + patioOpenExisting;
                totalAddedPatioCalculated += patioCoverageAdded + patioOpenAdded;
                PropertyFormGroup.get("totalExistingPatio").setValue(totalExistingPatioCalculated);
                PropertyFormGroup.get("totalAddedPatio").setValue(totalAddedPatioCalculated);
            }
        }
        catch (e) {
            // Ignore this, the user might give invalid inputs which are handled by the validators
        }
        try {
            const mainBuildings = PropertyFormGroup.get("mainBuildings");
            const outbuildings = PropertyFormGroup.get("outBuildings");
            mainBuildings.controls.forEach(building => {
                totalExistingCalculated += building.get("existingSize").value;
                totalAddedCalculated += building.get("addedSize").value;
                if (building.get("floor").value === 0) {
                    totalGroundFloorCalculated += building.get("existingSize").value;
                    totalGroundFloorCalculated += building.get("addedSize").value;
                }
            });
            outbuildings.controls.forEach(building => {
                totalExistingCalculated += building.get("existingSize").value;
                totalAddedCalculated += building.get("addedSize").value;
                if (building.get("floor").value === 0) {
                    totalGroundFloorCalculated += building.get("existingSize").value;
                    totalGroundFloorCalculated += building.get("addedSize").value;
                }
            });
            totalFloorCalculated = totalAddedCalculated + totalExistingCalculated;
            PropertyFormGroup.get("totalExisting").setValue(totalExistingCalculated);
            PropertyFormGroup.get("totalAdded").setValue(totalAddedCalculated);
            PropertyFormGroup.get("totalFloorArea").setValue(totalFloorCalculated);
        }
        catch (e) {
            // Ignore this, the user might give invalid inputs which are handled by the validators
        }
        try {
            if (PropertyFormGroup.get("patioCoveredExisting").value !== null && PropertyFormGroup.get("patioCoveredAdded").value !== null && PropertyFormGroup.get("erfSize").value !== null) {
                const patioCoverageExisting = PropertyFormGroup.get("patioCoveredExisting").value;
                const patioCoverageAdded = PropertyFormGroup.get("patioCoveredAdded").value;
                const totalCoveredPatio = 0.00 + patioCoverageExisting + patioCoverageAdded;
                const totalCoveredArea = 0.00 + totalExistingCalculated + totalAddedCalculated + totalCoveredPatio;
                const totalFloorArea = 0.00 + totalGroundFloorCalculated + totalCoveredPatio;
                const totalArea = 0.00 + PropertyFormGroup.get("erfSize").value;
                const bulkCalculation = totalCoveredArea / totalArea;
                const covered = totalFloorArea / totalArea * 100;
                PropertyFormGroup.get("coverage").setValue(Math.round(covered * 100) / 100);
                PropertyFormGroup.get("bulkCalculation").setValue(Math.round(bulkCalculation * 100) / 100);
            }
        }
        catch (e) {
            // Ignore this, the user might give invalid inputs which are handled by the validators
        }
    }
    static ctorParameters = () => [
        { type: ApplicationViewService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: MapService },
        { type: RequestStatusService },
        { type: ChangeDetectorRef },
        { type: RouterParamsService }
    ];
    static propDecorators = {
        mapComponent: [{ type: ViewChild, args: ["esrimap", { static: true },] }]
    };
};
ViewApplicationLocationBpamsComponent = __decorate([
    Component({
        selector: "app-view-application-location-bpams",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsubPortal()
], ViewApplicationLocationBpamsComponent);
export { ViewApplicationLocationBpamsComponent };
